import * as types from '../../lib/constants';

const initialState = {
  probabiliMethode: { homeTeam: {}, awayTeam: {} },
  isLineupLoaded: false,
};

function reverseAwayTeam(lineups) {
  const reversedLineups = lineups;
  if (lineups && lineups.formationModule) {
    const reversedSchema = lineups.formationModule.reverse();
    Object.assign(reversedLineups.formationModule, reversedSchema);
  }
  return reversedLineups;
}

export default function probabiliReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_PROBABILI_SUCCESS:
      return {
        ...state,
        probabiliMethode: {
          ...state.probabiliMethode,
          homeTeam: {
            ...state.probabiliMethode.homeTeam,
            teamId: action.data.squadHomeId,
          },
          awayTeam: {
            ...state.probabiliMethode.awayTeam,
            teamId: action.data.squadAwayId,
          },
        },
      };
    case types.GET_PROBABILI_HOME_SUCCESS:
      return {
        ...state,
        probabiliMethode: {
          ...state.probabiliMethode,
          homeTeam: Object.assign({}, state.probabiliMethode.homeTeam, action.data),
        },
      };
    case types.GET_PROBABILI_AWAY_SUCCESS:
      return {
        ...state,
        probabiliMethode: {
          ...state.probabiliMethode,
          awayTeam: Object.assign({}, state.probabiliMethode.awayTeam, reverseAwayTeam(action.data)),
        },
      };
    case types.GET_PROBABILI_HOME_ERROR:
      return {
        ...state,
        probabili: {
          ...state.probabili,
          MethodeHome: 'error',
        },
        isLineupLoaded: true,
      };
    case types.GET_PROBABILI_AWAY_ERROR:
      return {
        ...state,
        probabili: {
          ...state.probabili,
          MethodeAway: 'error',
        },
        isLineupLoaded: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/demo/reducers/probabili.js